import React from "react";

const ClientProfilePicture = ({ imageUrl, altText }) => {
	return (
		<div className='client-profile-picture w-12 h-12 rounded-full border-2 border-gray-900 overflow-hidden'>
			<img
				src={imageUrl}
				alt={altText}
				className='w-full h-full object-cover'
			/>
		</div>
	);
};

export default ClientProfilePicture;
